<template>
  <div class="paragraghFullhtml">
    <template v-if="fullHtml.js_code != null">
      <div v-html="fullHtml.value" />
      <div v-html="jsGen" />
    </template>
    <template v-else>
      <div v-html="fullHtml.value" />
    </template>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    cms_response: { type: Object, default: null },
    showTitle: { type: Boolean, required: false, default: true }
  }
})
export default class ParagraphFullhtml extends Vue {
  cms_response!: object;
  showTitle!: boolean;

  data: any = null;
  fullHtml = {
    title: "",
    type: "",
    js_code: "",
    value: ""
  };

  get jsGen() {
    const str: string = this.fullHtml.js_code;
    const jqueryCode = new Function(str);
    setTimeout(function() {
      jqueryCode();
    }, 10);
    return '';
  }

  makeFullhtml(obj: any) {
    this.fullHtml = {
      title: obj.data[0].attributes.title,
      type: obj.included[0].type,
      value: obj.included[0].attributes.field_fullhtml_text.value,
      js_code: obj.data[0].attributes.js_code
    };

    this.handleStyle(this.fullHtml);
  }

  handleStyle(fullHtml: {
    title: string;
    type: string;
    js_code: string;
    value: string;
  }) {
    fullHtml.value = fullHtml.value
      .replaceAll("background:#FFFFFF;", "background:#f4f4f4;")
      .replace(
        "ul.top-blockcontents-accessranking__koma li {",
        "ul.top-blockcontents-accessranking__koma li { background:#FFFFFF;"
      );
  }

  mounted() {
    this.makeFullhtml(this.cms_response);
  }
}
</script>

<style lang="scss" scoped></style>
